import AzureBlob from "../../../../contents/docs/cdp/sources/_snippets/source-azure-blob.mdx";
import * as React from 'react';
export default {
  AzureBlob,
  React
};